export default [
  {
    "id": "All",
    "label": "All",
    "value": null,
    "color": "#81d4fa"
  },
  {
    "id": "Black & White",
    "label": "Black & White",
    "value": null,
    "color": "#eeeeee"
  },
  {
    "id": "Travel",
    "label": "Travel",
    "value": null,
    "color": "#ffe0b2"
  },
  {
    "id": "Portrait",
    "label": "Portrait",
    "value": null,
    "color": "#c8e6c9"
  },
  {
    "id": "Paris",
    "label": "Paris",
    "value": null,
    "color": "#d1c4e9"
  }
]
